module.exports = __webpack_public_path__ + "static/contact-5f714d4d37cbb372175a6e5b845f8a5d.svg";